module.exports = __webpack_public_path__ + "static/img/04.a989cd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/subscribe/04.jpg
// module id = R48S
// module chunks = 1